import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withLocalize, Translate } from 'react-localize-redux';
import { pick } from 'lodash';
import { searchActions } from '../../../store/searchStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';
import PropertyCzParcel from './propertyCzParcel';
import PropertyCzBuilding from './propertyCzBuilding';
import PropertyCzFlat from './propertyCzFlat';
import PropertyCzRealRight from './propertyCzRealRight';

import './propertyCz.scss';
import OldStyleTableWithHistory from '../../common/oldStyleTableWithHistory';
import { OldStyleSection_StandAlone } from '../../common/oldStyleSection';
import { MomentDate } from '../../common/momentComponent';

class PropertyCzOwnershipDocumentDetail extends React.Component {
    static propTypes = {
        data: PropTypes.object.isRequired
    };

    render() {
        const data = this.props.data;
        const ownershipData = pick(data, ['ownerName', 'ownerAddress', 'ownershipDocumentId', 'share']);
        return (
            <div className="cuzk-od-detail">
                {!isNullOrUndefined(data.owners) && data.owners.length > 0 && this.renderOwners(data.owners)}
                {!isNullOrUndefined(data.parcels) && data.parcels.length > 0 && this.renderParcels(data.parcels, ownershipData)}
                {!isNullOrUndefined(data.buildings) && data.buildings.length > 0 && this.renderBuildings(data.buildings)}
                {!isNullOrUndefined(data.flats) && data.flats.length > 0 && this.renderFlats(data.flats)}
                {!isNullOrUndefined(data.authorizations) && data.authorizations.length > 0 && this.renderAuthorizations(data.authorizations)}
                {!isNullOrUndefined(data.restrictions) && data.restrictions.length > 0 && this.renderRestrictions(data.restrictions)}
                {!isNullOrUndefined(data.otherNotes) && data.otherNotes.length > 0 && this.renderOtherNotes(data.otherNotes)}
                {!isNullOrUndefined(data.warnings) && data.warnings.length > 0 && this.renderWarnings(data.warnings)}
                {!isNullOrUndefined(data.acquireDocuments) && data.acquireDocuments.length > 0 && this.renderAcquireDocuments(data.acquireDocuments)}
                {!isNullOrUndefined(data.qualities) && data.qualities.length > 0 && this.renderQualities(data.qualities)}
            </div>
        );
    }

    renderOwners = (owners) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.OwnersSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory colWidths={['25%','25%','25%','25%']} 
                    head={() => <thead>
                        <tr>
                            <th><Translate id="PropertyCz.Report.OD.PropertyRight" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Address" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Share" /></th>
                            <th><Translate id="PropertyCz.Report.OD.TypeOfLegalRel" /></th>
                        </tr>
                    </thead>} fixed classNames='old-style-bordered' actualData={owners} actualRow={o => <tr key={o.id}>
                        <td>{o.owner}</td>
                        <td>{o.ownerAddress}</td>
                        <td>{o.share}</td>
                        <td>{o.relationType}</td>
                    </tr>}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderParcels = (parcels, ownershipData) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.ParcelsSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["","20%","16%","16%","16%","16%","11%"]}
                    head={() => <thead>
                        <tr>
                            <th style={{width:'5em'}}></th>
                            <th><Translate id="PropertyCz.Report.OD.ParcelType" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Parcel" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Area" options={{ renderInnerHtml: true }} /></th>
                            <th colSpan={3}><Translate id="PropertyCz.Report.OD.Restriction" /></th>
                        </tr>
                    </thead>} 
                    actualData={parcels} fixed classNames='old-style-bordered'
                    actualRow={p => <PropertyCzParcel key={p.id} telId={this.props.telId} data={p} ownershipData={ownershipData} />}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderBuildings = (buildings) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.BuildingsSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["","20%","20%","20%","20%","15%"]}
                    colWidthsOnMobile={false}
                    head={() => <thead>
                        <tr>
                            <th style={{width:'5em'}}></th>
                            <th><Translate id="PropertyCz.Report.OD.BuildingType" /></th>
                            <th colSpan={2}><Translate id="PropertyCz.Report.OD.HouseNo" /></th>
                            <th><Translate id="PropertyCz.Report.OD.BuildingNo" /></th>
                            <th style={{width:'8em'}}><Translate id="PropertyCz.Report.OD.Restriction" /></th>
                        </tr>
                    </thead>} 
                    actualData={buildings} fixed classNames='old-style-bordered'
                    actualRow={b => <PropertyCzBuilding key={b.id} telId={this.props.telId} data={b} />}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderFlats = (flats) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.UnitsSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["","60%","20%","15%"]}
                    head={() => <thead>
                        <tr>
                            <th style={{width:'5em'}}></th>
                            <th><Translate id="PropertyCz.Report.OD.UnitType" /></th>
                            <th><Translate id="PropertyCz.Report.OD.UnitNumber" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Restriction" /></th>
                        </tr>
                    </thead>} 
                    actualData={flats} fixed classNames='old-style-bordered'
                    actualRow={f => <PropertyCzFlat key={f.id} telId={this.props.telId} data={f} />}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderAuthorizations = (authorizations) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.AuthorizationsSection")} isOpen hasData hasSpace isBold>
                {authorizations.map(a => <PropertyCzRealRight key={a.jpvId} data={a} showRestriction={false} />)}
            </OldStyleSection_StandAlone>
        );
    }

    renderRestrictions = (restrictions) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.OwnershipRestrictionSection")} isOpen hasData hasSpace isBold>
                {restrictions.map(r => <PropertyCzRealRight key={r.jpvId} data={r} />)}
            </OldStyleSection_StandAlone>
        );
    }

    renderOtherNotes = (notes) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.OtherNotesSection")} isOpen hasData hasSpace isBold>
                {notes.map(n => <PropertyCzRealRight key={n.jpvId} data={n} showRestriction={false} />)}
            </OldStyleSection_StandAlone>
        );
    }

    renderWarnings = (warnings) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.WarningsSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["25%","20%","20%","35%"]}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="PropertyCz.Report.OD.RestrictionName" /></th>
                            <th><Translate id="PropertyCz.Report.OD.SubmissionDate" /></th>
                            <th><Translate id="PropertyCz.Report.OD.SubmissionNo" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Properties" /></th>
                        </tr>
                    </thead>} 
                    actualData={warnings} fixed classNames='old-style-bordered'
                    actualRow={w => <tr key={w.id}>
                        <td>{w.name}</td>
                        <td>
                            {isNullOrUndefined(w.submissionDate) ? null
                                : <><MomentDate value={w.submissionDate} /> <MomentDate format="LTS" value={w.submissionDate} /></>}
                        </td>
                        <td>{w.submissionNumber}</td>
                        <td style={{ whiteSpace: "pre-wrap" }}>{w.properties}</td>
                    </tr>}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderAcquireDocuments = (acquireDocuments) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.AcquireDocumentsSection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["50%","20%","30%"]}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="PropertyCz.Report.OD.Document" /></th>
                            <th><Translate id="PropertyCz.Report.OD.ProceedingNumber" /></th>
                            <th><Translate id="PropertyCz.Report.OD.For" /></th>
                        </tr>
                    </thead>} 
                    actualData={acquireDocuments} fixed classNames='old-style-bordered'
                    actualRow={a => <tr key={a.id}>
                        <td>{a.document}</td>
                        <td>{a.documentNumber}</td>
                        <td style={{ whiteSpace: "pre-wrap" }}>{a.authorizationFor}</td>
                    </tr>}
                />
            </OldStyleSection_StandAlone>
        );
    }

    renderQualities = (qualities) => {
        return (
            <OldStyleSection_StandAlone name={this.props.translate("PropertyCz.Report.OD.QualitySection")} isOpen hasData hasSpace isBold>
                <OldStyleTableWithHistory
                    colWidths={["50%","20%","30%"]}
                    head={() => <thead>
                        <tr>
                            <th><Translate id="PropertyCz.Report.OD.Parcel" /></th>
                            <th><Translate id="PropertyCz.Report.OD.BpejCode" /></th>
                            <th><Translate id="PropertyCz.Report.OD.Area" options={{ renderInnerHtml: true }} /></th>
                        </tr>
                    </thead>} 
                    actualData={qualities} fixed classNames='old-style-bordered'
                    actualRow={q => <tr key={q.id}>
                        <td>{q.parcelNumber}</td>
                        <td>{q.code}</td>
                        <td>{q.area}</td>
                    </tr>}
                />
            </OldStyleSection_StandAlone>
        );
    }
}

export default withLocalize(connect(
    state => ({ search: { ...state.search.cuzk } }),
    dispatch => bindActionCreators(searchActions, dispatch),
)(PropertyCzOwnershipDocumentDetail));